import { Injectable } from '@angular/core'
import { EntitySignalStore } from '@awork/core/state/signal-store/entitySignalStore'
import { TaskViewList } from '@awork/features/task/models/task-view-list.model'
import { syncStore } from '@awork/core/state/signal-store/sync-store'

@Injectable({ providedIn: 'root' })
export class TaskViewStore extends EntitySignalStore<TaskViewList> {
  constructor() {
    super({ name: 'taskView', entityConstructor: taskView => new TaskViewList(taskView) })
  }

  /**
   * Synchronize the store with the data fetched from the API
   * Add new, update existing and remove non-existing task view lists
   * @param {TaskViewList[]} taskViewLists
   * @param {TaskViewList[]} storedTaskViewLists
   */
  sync(taskViewLists: TaskViewList[], storedTaskViewLists: TaskViewList[]): void {
    syncStore(taskViewLists, storedTaskViewLists, this, { compareProp: 'updatedOn', keepProp: 'taskIds' })
  }

  /**
   * Synchronize a single task view list with the data fetched from the API
   * @param {TaskViewList} taskView
   */
  syncEntity(taskView: TaskViewList): void {
    const storedTaskViewList = this.entityMap()[taskView.id]
    let nextTaskViewList = storedTaskViewList

    if (!storedTaskViewList || taskView.updatedOn !== storedTaskViewList.updatedOn) {
      nextTaskViewList = new TaskViewList({
        ...taskView,
        taskIds: storedTaskViewList.taskIds
      })
    }

    super.syncEntity(nextTaskViewList)
  }
}
